import { inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE } from '../tokens';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    private readonly localStorage = inject(LOCAL_STORAGE);

    public get<T>(key: string): T | null {
        const data = this.localStorage.getItem(key);

        return data ? JSON.parse(data) : null;
    }

    public set<T>(key: string, data: T): void {
        const body = JSON.stringify(data);

        this.localStorage.setItem(key, body);
    }

    public remove(key: string): void {
        this.localStorage.removeItem(key);
    }

    public clear(): void {
        this.localStorage.clear();
    }
}
